import * as React from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { getAssetURL } from 'lib/utility/GetAssetUrl'
import styles from 'components/Shared/NoData/noData.module.scss'
import variables from 'assets/styles/scss/shared/_variables.module.scss'

type Props = {
  noDataImageClass?: string
} & typeof defaultProps

const defaultProps = {
  noDataImageClass: 'emptyImage-default-size',
}

const NoDataComp = (props: Props) => {
  const { t } = useTranslation()
  const { noDataImageClass } = props

  return (
    <Box className={`${styles.emptyImage} ${styles[noDataImageClass]}`}>
      <img src={getAssetURL('/empty/noData.svg')} alt="" />
      <Typography
        variant="subtitle2"
        textAlign={'center'}
        color={variables['grey-22']}
        fontWeight={'400'}
        padding={1}
      >
        {t('common.noDataToDisplay')}
      </Typography>
    </Box>
  )
}
NoDataComp.defaultProps = defaultProps

export default NoDataComp
